import { ClientPortalBrandHeader } from './client-portal-brand-header';

type ClientPortalMobileTopBarProps = {
  readonly firmName: string | null;
  readonly firmLogoUrl: string | null;
  readonly brandingLoading: boolean;
};

export function ClientPortalMobileTopBar({ firmName, firmLogoUrl, brandingLoading }: ClientPortalMobileTopBarProps) {
  return (
    <header className="flex h-12 shrink-0 items-center border-b border-border-light bg-card px-4 md:hidden print:hidden">
      <ClientPortalBrandHeader firmName={firmName} firmLogoUrl={firmLogoUrl} isLoading={brandingLoading} />
    </header>
  );
}
